module.exports = {
	"id": "IT",
	"name": "Italy",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.019314,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.012876,
			"22": 0.051504,
			"23": null,
			"24": null,
			"25": 0.038628,
			"26": 0.03219,
			"27": 0.006438,
			"28": null,
			"29": 0.006438,
			"30": null,
			"31": 0.038628,
			"32": 0.019314,
			"33": 0.019314,
			"34": 0.057942,
			"35": 0.038628,
			"36": 0.06438,
			"37": 0.025752,
			"38": 0.057942,
			"39": 0.057942,
			"40": 0.038628,
			"41": 0.045066,
			"42": 0.045066,
			"43": 0.212454,
			"44": 0.051504,
			"45": 0.070818,
			"46": 0.070818,
			"47": 0.077256,
			"48": 0.109446,
			"49": 2.819844,
			"50": 0.167388,
			"51": 0.502164,
			"52": 0.682428,
			"53": 23.704716,
			"54": 6.438,
			"55": 0.06438,
			"56": 0.019314,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.012876,
			"12": 0.012876,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.025752,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.012876,
			"21": 0.006438,
			"22": null,
			"23": null,
			"24": 0.006438,
			"25": null,
			"26": 0.006438,
			"27": 0.006438,
			"28": 0.012876,
			"29": 0.012876,
			"30": 0.012876,
			"31": 0.019314,
			"32": 0.006438,
			"33": 0.012876,
			"34": 0.038628,
			"35": 0.019314,
			"36": 0.019314,
			"37": 0.03219,
			"38": 0.057942,
			"39": 0.038628,
			"40": 0.025752,
			"41": 0.03219,
			"42": 0.045066,
			"43": 0.424908,
			"44": 0.057942,
			"45": 0.25752,
			"46": 0.103008,
			"47": 0.830502,
			"48": 0.978576,
			"49": 8.446656,
			"50": 0.103008,
			"51": 0.006438,
			"52": null,
			"3.5": null,
			"3.6": 0.025752
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.012876,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.038628,
			"37": 0.025752,
			"38": 0.038628,
			"39": 0.090132,
			"40": 0.540792,
			"41": 0.070818,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.051504
		},
		"safari": {
			"0": null,
			"4": 0.025752,
			"5": 0.083694,
			"6": 0.019314,
			"7": 0.038628,
			"8": 0.206016,
			"9": 0.28971,
			"10": 2.2533,
			"3.1": null,
			"3.2": null,
			"5.1": 0.218892,
			"6.1": 0.122322,
			"7.1": 0.019314,
			"9.1": 1.22322
		},
		"ios_saf": {
			"8": 0,
			"10": 5.34719966028,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.144100843464,
			"8.1-8.4": 0.266220202331,
			"9.0-9.2": 0.127004133222,
			"9.3": 1.9376271607
		},
		"android": {
			"3": 0,
			"4": 0.0409768062016,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00512210077519,
			"4.1": 0.147809193798,
			"4.2-4.3": 0.369522984496,
			"4.4": 0.847341813953,
			"4.4.3-4.4.4": 0.854659100775
		},
		"ie": {
			"6": 0.0129444893617,
			"7": 0.0258889787234,
			"8": 0.407751414894,
			"9": 0.310667744681,
			"10": 0.220056319149,
			"11": 5.10660105319,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0135104718278,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000375290884104
		},
		"edge": {
			"12": 0.103008,
			"13": 0.6438,
			"14": 1.744698
		},
		"ie_mob": {
			"10": 0.268303887324,
			"11": 1.09238011268
		},
		"bb": {
			"7": 0.0133575,
			"10": null
		},
		"samsung": {
			"0": 3.911076
		},
		"and_uc": {
			"0": 0.413192
		},
		"op_mini": {
			"0": 0.182024237288
		},
		"and_chr": {
			"0": 20.760052
		},
		"and_ff": {
			"0": 0.049868
		}
	},
	"total": 98.1136735
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/IT.json
 ** module id = 555
 ** module chunks = 0
 **/